var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIscenario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46419 0.837891L18.9283 6.16149V12.6681H16.5623V8.53198L10.6471 11.9471V18.7506L11.8302 18.0851V20.8014L9.46419 22.1323L0 16.8087V6.16149L9.46419 0.837891ZM2.36601 8.59664V15.4245L8.28113 18.7508V12.0117L2.36601 8.59664ZM9.46413 3.55292L3.83998 6.71553L9.40812 9.93032L15.0307 6.68414L9.46413 3.55292ZM13.0132 13.8511H22.4774V16.2171H13.0133L13.0132 13.8511ZM13.0132 17.4002H22.4774V19.7662H13.0133L13.0132 17.4002ZM13.0132 20.9493H22.4774V23.3153H13.0133L13.0132 20.9493Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIscenario);
export default __webpack_public_path__ + "static/media/Iscenario.be57e5b0f0957aba7d6757f40a0d293f.svg";
export { ForwardRef as ReactComponent };